import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import { action } from 'satcheljs/lib/legacy';
import { getDefaultFolderToLoad } from 'mini-mail-folder-store/lib/utils/getDefaultFolderToLoad';
import { selectFolderInternal } from './selectFolder';

export default action('selectDefaultFolder', { datapoint: { name: 'selectDefaultFolder' } })(
    function selectDefaultFolder(): void {
        const folderId = getDefaultFolderToLoad();
        const focusedViewFilter = isFocusedInboxEnabled() ? 0 : -1;
        // Call selectFolderInternal here to separate datapoint selectDefaultFolder from selectFolder
        selectFolderInternal(folderId, focusedViewFilter);
    }
);
